import React from 'react';

const UpChartIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 7H22M22 7V13M22 7L13.5 15.5L8.5 10.5L2 17'
        stroke='#00B73F'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default UpChartIcon;
